import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import OpenNetworkLogComponent from '../components/open-network-log.component';
import { selectListItems } from '../../../../../../redux/library/selector';
import { opennetworkDomains } from '../../../../../../redux/opennetwork-domains/action';
import { selectOpennetworkDomainsListItems } from '../../../../../../redux/opennetwork-domains/selector';

const ManagementOpenNetworkLog = () => {
  const dispatch = useAppDispatch()
  const libraryData = useSelector(selectListItems)
  const domainListData = useSelector(selectOpennetworkDomainsListItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectOpenNetworkLogs, setSelectOpenNetworkLogs] = useState<any>({
    TransactionId: '',
    MessageId: '',
    BuyerId: '',
    SellerId: '',
    DomainId: '',
    City: '',
  });
  const [showResults, setShowResults] = useState(false);

  useEffect(() => {
  }, [selectOpenNetworkLogs])

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectOpenNetworkLogs({ ...selectOpenNetworkLogs, [field]: event });
  }

  const fetchTenantOpenNetworkDomainsList = async () => {
    dispatch(opennetworkDomains.resetAction({ actionType: 'list' }))
    dispatch(opennetworkDomains.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-domains/dbn-fetch`,
      entity: 'tenantOpenNetworkDomains',
      jsonData: {
        "Context": {},
        "Records": [
          {
            "IsSubDomain": null //to get all records
          }
        ],
        "Pagination": {

        }
      }
    }))
  }

  const formatDomainListData = (data: any) => {
    return _.map(data, (items: any) => {
      const item = {
        Id: items?.Id,
        Name: `${items?.Name} (${items?.Code})`,
      };
      return item
    });
  };

  useEffect(() => {
    fetchTenantOpenNetworkDomainsList()
    setIsLoading(false)
  }, []
  )

  const handleClearFilter = (event: any) => {
    event.preventDefault();
    setSelectOpenNetworkLogs({
      TransactionId: '',
      MessageId: '',
      BuyerId: '',
      SellerId: '',
      DomainId: '',
      City: '',
    });
    setShowResults(false);
  };

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    setShowResults(true);
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <div>
          <OpenNetworkLogComponent
            key={JSON.stringify(selectOpenNetworkLogs)}
            handleInnerFormChange={handleInnerFormChange}
            selectOpenNetworkLogs={selectOpenNetworkLogs}
            handleFormSubmit={handleFormSubmit}
            handleClearFilter={handleClearFilter}
            actionList={libraryData?.result?.RetailRequestType}
            dateRangesList={libraryData?.result?.DateTimeWindow}
            domainList={formatDomainListData(domainListData?.result?.items)}
            showResults={showResults}
          />
        </div>
      }
    </>
  )
};

export default ManagementOpenNetworkLog;
